import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectChangeEventDetail } from '@ionic/core';
import { City } from 'src/app/interfaces/city';
import { Sort, WishlistSortBy } from 'src/app/pages/tabWishlist/tabWistlist.page';

@Component({
  selector: 'app-popover-wishlist-sort-filter',
  templateUrl: './popover-wishlist-sort-filter.component.html',
  styleUrls: ['./popover-wishlist-sort-filter.component.scss'],
})
export class PopoverWishlistSortFilterComponent implements OnInit {
  @Input() sortByList: WishlistSortBy[];
  @Input() cities: City[];

  @Input() initial_sort: Sort;
  @Input() initial_sort_by: WishlistSortBy = 'date';
  @Input() initial_filter_by: number | undefined;

  @Output() changeSort = new EventEmitter();
  @Output() changeSortBy = new EventEmitter();
  @Output() changeFilter = new EventEmitter();
  @Output() resetFilter = new EventEmitter();

  sortListByCity = [
    { id: 'ASC', name: 'Ascending' },
    { id: 'DESC', name: 'Descending' },
  ];
  sortListByDate = [
    { id: 'DESC', name: 'Latest' },
    { id: 'ASC', name: 'Oldest' },
  ];

  constructor() {}

  ngOnInit() {}

  onSelectSort(e: Event) {
    const customEvent = e as CustomEvent<SelectChangeEventDetail>;
    const value = customEvent.detail.value;
    if (!value) {
      return;
    }

    this.initial_sort = value;
    this.changeSort.emit({ selected_sort: value });
  }

  onSelectSortBy(e: Event) {
    const customEvent = e as CustomEvent<SelectChangeEventDetail>;
    const value = customEvent.detail.value;
    if (!value) {
      return;
    }

    this.initial_sort_by = value;
    this.changeSortBy.emit({ selected_sort_by: value });
  }

  onSelectCity(e: Event) {
    const customEvent = e as CustomEvent<SelectChangeEventDetail>;
    const value = customEvent.detail.value;

    let selected_city: City | undefined;

    if (!value) {
      selected_city = undefined;
      this.initial_filter_by = undefined;
    }

    selected_city = this.cities.find(city => city.id === value);
    this.initial_filter_by = selected_city?.id;

    console.log(selected_city);
    this.changeFilter.emit({ selected_city });
  }

  resetFilterHandler() {
    this.resetFilter.emit();
  }
}
